// Centralizes loading of vuex modules and routes
// In this way, the maintenance of the application modules becomes simpler

export { default as vuex } from './vuex'
export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/index.js